





















































import {forEach, isBrowser, isEmpty, merge, PlainObject} from '@labor-digital/helferlein';
import {createPopper, Instance as Popper, Placement} from '@popperjs/core';
import {Component, Vue} from 'vue-property-decorator';
import VuDropdownAbstract from './VuDropdownAbstract.vue';

@Component
export default class VuDropdownTemplate extends Vue
{

    get p(): VuDropdownAbstract
    {
        return this.$parent as any;
    }

    get hasTrigger(): boolean
    {
        return !isEmpty(this.$scopedSlots.trigger);
    }

    get classes(): PlainObject
    {
        const baseClass = 'vuDropdown--';
        return {
            [baseClass + this.p.type]: true,
            [baseClass + this.p.direction]: true,
            [baseClass + 'open']: this.p.isOpen,
            [baseClass + 'dynWidth']: !this.p.asBlock,
            [baseClass + 'disabled']: this.p.disabled,
            [baseClass + 'withArrow']: this.p.withArrow
        };
    }

    protected popper: Popper | null = null;

    /**
     * Creates a new popper instance based on the current configuration
     * The old instance will be destroyed automatically
     * @protected
     */
    protected createPopper(): void
    {
        this.destroyPopper();

        if (isBrowser() && this.p.isOpen) {
            const reference = (() => {
                if (this.hasTrigger) {
                    return this.$refs.trigger;
                }
                if (this.p.parentIsReference) {
                    return this.p.$parent.$el ?? this.p.$parent;
                }
                return this.$el;
            })();

            const placement = ({
                left: 'left-start',
                right: 'right-start',
                up: 'top-start',
                down: 'bottom-start'
            })[this.p.direction] as Placement;

            const modifiers = [];
            if (this.p.noFlip) {
                modifiers.push({name: 'flip', enabled: false});
            }
            if (this.p.withArrow) {
                modifiers.push({name: 'offset', options: {offset: [0, 10]}});
            }

            const config = merge({placement, modifiers}, this.p.popperOptions);

            this.popper = createPopper(
                reference as HTMLElement,
                this.$refs.body as HTMLElement, config as any);
        }
    }

    /**
     * Recreates the popper instance on the next tick
     */
    protected recreatePopper(): void
    {
        this.$nextTick(() => this.createPopper());
    }

    /**
     * Destroys the current popper instance
     * @protected
     */
    protected destroyPopper(): void
    {
        this.popper && this.popper.destroy();
        this.popper = null;
    }

    public created()
    {
        forEach([
            'noFlip', 'direction', 'value', 'popperOptions', 'asBlock', 'withArrow', 'fallbackValue'
        ], (field) => {
            this.$watch(() => this.p[field], () => this.recreatePopper());
        });
    }

    public beforeDestroy()
    {
        this.destroyPopper();
    }

}
